import React, { type CSSProperties } from 'react'

import { TtFlavorContext } from '@23/react'

import { useWebinarColors } from '../sharedLegacy/hooks/useWebinarColors'

import { useFocusMode } from './blocs/useFocusMode'
import { FocusPane } from './components/FocusPane/FocusPane'
import { FocusHeader } from './components/FocusPane/Panes/FocusHeader/FocusHeader'
import { FocusFooter } from './components/FocusPane/Panes/FocusFooter/FocusFooter'

import './FocusMode.scss'

const FocusMode = () => {
  const { panes } = useFocusMode()
  const webinarColors = useWebinarColors()

  return (
    <TtFlavorContext flavor="webinars">
      <div
        className="focus-mode"
        style={
          {
            '--webinar-color-accent': webinarColors.accent.color,
            '--webinar-color-sidebar': webinarColors.sidebar.color,
            '--webinar-color-tabs': webinarColors.tabs.color,
            '--webinar-color-sidebar-text':
              webinarColors.sidebar.highContrast.color,
            '--webinar-color-sidebar-ctacontrast':
              webinarColors.sidebar.contrast.color,
            '--webinar-color-tabs-text': webinarColors.tabs.highContrast.color,
            '--webinar-color-tabs-ctacontrast':
              webinarColors.tabs.contrast.color,
            '--webinar-color-accent-text':
              webinarColors.accent.highContrast.color,
            '--webinar-color-accent-ctacontrast':
              webinarColors.accent.contrast.color,
            '--webinar-color-inputBox':
              webinarColors.sidebar.contrast.color === '#000000'
                ? 'rgba(0, 0, 0, 0.05)'
                : 'rgba(0, 0, 0, 0.15)',
          } as CSSProperties
        }
      >
        <FocusHeader />
        <div className="focus-mode-panes">
          {panes.map((_, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <FocusPane key={idx} idx={idx} />
          ))}
        </div>
        <FocusFooter />
      </div>
    </TtFlavorContext>
  )
}

export { FocusMode }
